import {
  HourlyStationValueDTO,
  HourlyStationValuesDTO
} from '@models/api/station/HourlyStationValuesDTO'
import { HourlyStationVariableID } from '@models/station/HourlyStationVariable'
import { Station } from '@models/Station'
import dayjs, { Dayjs } from 'dayjs'

export class HourlyStationValue {
  public unix: number
  constructor(
    public date: Dayjs,
    public value: number
  ) {
    this.unix = date.startOf('minute').unix()
  }

  static fromDTO(dto: HourlyStationValueDTO): HourlyStationValue {
    return new HourlyStationValue(dayjs(dto.DATE), dto.VALUE)
  }
}

export class HourlyStationValues {
  public valuesDict: { [key: number]: HourlyStationValue } = {}

  private constructor(
    public stationId: Station['id'],
    values: HourlyStationValue[],
    public variable: HourlyStationVariableID
  ) {
    values.forEach((value) => {
      this.valuesDict[value.unix] = value
    })
  }

  get values() {
    return Object.values(this.valuesDict)
  }

  static fromDTO(
    dto: HourlyStationValuesDTO,
    variable: HourlyStationVariableID
  ): HourlyStationValues {
    return new HourlyStationValues(
      dto.STATION_ID,
      dto.VALUES.map(HourlyStationValue.fromDTO),
      variable
    )
  }
}
